<div class="hero-image-and-title" *ngIf="content">
  <app-picture
    [source]="content.fields.heroImage.fields.file.url"
    [isBackground]="true"
    [type]="'fullWidth'"
    [alt]="''"
  >
  </app-picture>
  <h1 class="title">
    {{ content?.fields.title }}
  </h1>
</div>
